import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "title-right"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    // 设置组件属性
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      return _openBlock(), _createBlock(_component_el_header, {
        class: "chat-header"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])]),
        _: 3
      });
    };
  }
});